export const GIC_VIEW_TYPE = 'GIC' as const;
